export const SET_WEB_SOCKET_CHANEL_SUCCESS = "SET_WEB_SOCKET_CHANEL_SUCCESS";
export const SET_WEB_SOCKET_CHANEL_REQUEST = "SET_WEB_SOCKET_CHANEL_REQUEST";

export const WEPS0CKET_REQUEST = "WEPS0CKET_REQUEST";
export const WEPS0CKET_OPEN = "WEPS0CKET_OPEN";
export const WEPS0CKET_CLOSE = "WEPS0CKET_CLOSE";

// status info

// SESSION_WAITING_ROOM_UPDATED "USER JOIN AND LEAVE WAITING ROOM"
// SESSION_STARTED "WAITING ROOM OPEN"
// SESSION_ANSWER_UPDATED "KETIKA ASSESSEE UPLOAD JAWABAN UNTUK METHODE TERTENTU"
export const SESSION_ROOM_UPDATED = "ROOM_UPDATED"; // untuk user join and leave waiting room
export const SESSION_STARTED = "SESSION_STARTED"; // untuk masuk ke main session
export const SESSION_ANSWER_UPDATED = "ANSWER_UPDATED"; // untuk lgd and fgd update value
export const SESSION_ENDED = "SESSION_ENDED"; // untuk end session for all user
